import DesktopScreen from "./DesktopScreen";

// Export without redux connection
export default DesktopScreen;
